import { EmpreintesCarboneEquipementsResponse } from '@services/interfaces/generated/obtenirEmpreintesCarboneEquipements';
import BytelAPIServicesBase from './BytelAPIServicesBase';
import { EmpreintesCarboneSearchFilters } from './types';
import { setQueryParams } from './utils';

/**
 * Service pour gérer les appels à l'API Bytel - Empreintes Carbone
 */
export default class EmpreintesCarboneAPIService extends BytelAPIServicesBase {
  /**
   * Récupère les détails des empreintes carbone par SIREN, équipements et date d'achat
   * @param options - Filtres de recherche
   * @returns Les détails des empreintes carbone
   */
  async obtenirEmpreintesCarboneEquipements(
    options?: EmpreintesCarboneSearchFilters,
  ): Promise<EmpreintesCarboneEquipementsResponse | undefined> {
    const endpoint = '/api/v1/empreintes-carbone-equipements';
    const url = await this.getUrl(endpoint);

    setQueryParams(url, options);

    return this.bquery.get<EmpreintesCarboneEquipementsResponse>(url.toString());
  }
}
